import React from 'react'
import formatTime from 'lib/format-time'
import classNames from 'classnames'

export interface IAnswer {
  text: string
  create_time: number
  user_id: number
  user_name: string
  avatar_url: string
  user_digg: boolean
  high_quality_comment: boolean
  label_url?: string
  image_url?: string
  user_verified: boolean
  motor_auth_show_info: {
    auth_v_type: number
  }
}

interface IProps {
  info: IAnswer
}

const vip_1_icon = require('static/yellow-v.png')
const vip_2_icon = require('static/v_blue_24.png')

const Answer = ({ info }: IProps) => {
  const {
    text,
    create_time,
    user_id,
    user_name,
    avatar_url,
    user_digg,
    high_quality_comment,
    label_url,
    image_url,
    motor_auth_show_info,
    user_verified,
  } = info
  const { auth_v_type } = motor_auth_show_info || {}
  return (
    <div className="ugc-answer">
      {image_url ? (
        <>
          <div className="answer-with-image">
            <img src={image_url} />
            <div className="line-2">{text}</div>
          </div>
        </>
      ) : (
        <>
          <div className="author">
            <span
              className={classNames('avatar', {
                'vip-1': user_verified && auth_v_type === 1,
                'vip-2': user_verified && auth_v_type === 2,
              })}
              style={{
                backgroundImage: `url(${avatar_url})`,
              }}
            />
            <span className="name">{user_name}</span>
          </div>
          <div className="answer line-2">{text}</div>
          {label_url && (
            <div
              className="stamp selected"
              style={{ backgroundImage: `url('${label_url}')` }}
            />
          )}
        </>
      )}

      <style jsx>
        {`
          .ugc-answer{
            position: relative;
            background-color: #f7f8fc;
            border-radius: 2px;
            overflow: hidden;
          }
          .answer-with-image{
            display: flex;
            align-items: center;
            padding: 16px;
          }
          .answer-with-image img{
            height: 44px;
            width: 44px;
            object-fit: cover;
            border-radius: 4px;
          }
          .answer-with-image div{
            margin-left: 13px;
            font-size: 14px;
            line-height: 22px;
            color: #1f2129;
          }
          .author{
            display: flex;
            margin: 16px auto 12px 24px;
            align-items: center;
          }
          .avatar {
            position: relative;
            width: 20px;
            height: 20px;
            background-size: cover;
            border-radius: 50%;
            cursor: pointer;
          }
          .vip-1::after, .vip-2::after{
            content: '';
            height: 8px;
            width: 8px;
            position: absolute;
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
            border-radius: 50%;
            right: 0;
            bottom: 0;
          }
          .vip-1::after{
            background-image: url('${vip_1_icon}');
          }
          .vip-2::after{
            background-image: url('${vip_2_icon}');
          }
          .name{
            color: #979aa8;
            font-size: 14px;
            font-weight: 500;
            line-height: 20px;
            margin-left: 8px;
          }
          .answer{
            margin-left: 24px;
            margin-bottom: 16px;
            width: 556px;
            color: #1f2129;
            font-size: 14px;
            line-height: 22px;
          }
          .stamp{
            top: 0;
            bottom: 0;
            right: 0;
            position: absolute;
            width: 60px;
            height: 60px;
            margin: auto 16px;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
          }
        `}
      </style>
    </div>
  )
}

export default Answer
